import { render, staticRenderFns } from "./TableEvaluation.vue?vue&type=template&id=be2aa876&scoped=true"
import script from "./TableEvaluation.vue?vue&type=script&lang=js"
export * from "./TableEvaluation.vue?vue&type=script&lang=js"
import style0 from "./TableEvaluation.vue?vue&type=style&index=0&id=be2aa876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2aa876",
  null
  
)

export default component.exports